module.exports = __webpack_public_path__ + "static/media/27OCHA3.7ce99f82.jpg";